// B7-6: 注销账户页(b9rrI2)
// pen frames: dogdisk-user.pen # b9rrI2
import { Spinner } from '@dogdisk/shared'
import { AppLayout } from '../../components/app-layout'
import { MobileScreen, TopBar } from '../../components/mobile-screen'
import {
  useCancelDeactivation,
  useDeactivationStatus,
  useRequestDeactivation,
} from '../../_lib/b7-api'

export function DeactivateAccountPage() {
  const { data, isLoading } = useDeactivationStatus()
  const req = useRequestDeactivation()
  const cancel = useCancelDeactivation()

  const onRequest = async () => {
    if (!confirm('确认提交注销请求?30 天后账号将被真删,期间可以随时取消')) return
    await req.mutateAsync()
  }
  const onCancel = async () => {
    await cancel.mutateAsync()
  }

  return (
    <AppLayout>
      <MobileScreen>
        <TopBar title="注销账户" />
        <div className="space-y-4 p-4">
          {isLoading ? (
            <Spinner />
          ) : data?.status === 'pending_deletion' ? (
            <div className="rounded-lg border border-red-300 bg-red-50 p-4">
              <h2 className="mb-2 text-base font-semibold text-red-800">注销已请求</h2>
              <p className="text-sm text-red-700">请求时间:{data.requested_at}</p>
              <p className="text-sm text-red-700">将于:{data.expires_at} 后真删</p>
              <button
                onClick={onCancel}
                disabled={cancel.isPending}
                className="mt-3 w-full rounded bg-red-600 py-2 text-sm text-white disabled:bg-gray-300"
              >
                取消注销
              </button>
            </div>
          ) : (
            <div className="rounded-lg border border-orange-300 bg-orange-50 p-4">
              <h2 className="mb-2 text-base font-semibold text-orange-800">注销说明</h2>
              <ul className="space-y-1 text-sm text-orange-700">
                <li>• 提交后 30 天宽限期内可随时取消</li>
                <li>• 30 天后账号将被真删,无法恢复</li>
                <li>• 资金类记录由系统按合规要求保留</li>
              </ul>
              <button
                onClick={onRequest}
                disabled={req.isPending}
                className="mt-3 w-full rounded bg-orange-600 py-2 text-sm text-white disabled:bg-gray-300"
              >
                我要注销账户
              </button>
            </div>
          )}
        </div>
      </MobileScreen>
    </AppLayout>
  )
}
